var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBooking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_946_4304)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_946_4304)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_946_4304",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 13
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2998 0.5C12.1282 0.5 12.7998 1.17157 12.7998 2V11C12.7998 11.8284 12.1282 12.5 11.2998 12.5H2.2998C1.47138 12.5 0.799805 11.8284 0.799805 11V2C0.799805 1.17157 1.47138 0.5 2.2998 0.5H11.2998ZM8.51407 9.1H3.37121C3.1503 9.1 2.97121 9.27909 2.97121 9.5C2.97121 9.72091 3.1503 9.9 3.37121 9.9H8.51407C8.73499 9.9 8.91407 9.72091 8.91407 9.5C8.91407 9.27909 8.73499 9.1 8.51407 9.1ZM10.2284 6.1H3.37121C3.1503 6.1 2.97121 6.27909 2.97121 6.5C2.97121 6.72091 3.1503 6.9 3.37121 6.9H10.2284C10.4493 6.9 10.6284 6.72091 10.6284 6.5C10.6284 6.27909 10.4493 6.1 10.2284 6.1ZM10.2284 3.1H3.37121C3.1503 3.1 2.97121 3.27909 2.97121 3.5C2.97121 3.72091 3.1503 3.9 3.37121 3.9H10.2284C10.4493 3.9 10.6284 3.72091 10.6284 3.5C10.6284 3.27909 10.4493 3.1 10.2284 3.1Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_946_4304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.799805 0.5H12.7998V12.5H0.799805V0.5Z",
    fill: "#5C1C81"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_946_4304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.799805 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_946_4304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.799805 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooking);
export default __webpack_public_path__ + "static/media/booking.0c32a126c36e694fbb44b61fac0d17dc.svg";
export { ForwardRef as ReactComponent };